import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const SignUpPrompt = () => {
	const { navigateWithLanguage } = useLanguageNavigate();
	const { t } = useTranslation();

	const handleSignupClick = () => {
		navigateWithLanguage('/register');
	};

	return (
		<p className="flex justify-center text-secondary roboto-regular text-center">
			{t('noAccount')}
			<Button
				variant="text"
				onClick={handleSignupClick}
				className="text-primary roboto-bold underline !capitalize !ml-[4px] cursor-pointer !py-[0] !px-[4px]"
			>
				{t('singUp')}
			</Button>
		</p>
	);
};
